import { render } from "./UpdatePolicyInfo.vue?vue&type=template&id=8ae5e34e&scoped=true"
import script from "./UpdatePolicyInfo.vue?vue&type=script&lang=js"
export * from "./UpdatePolicyInfo.vue?vue&type=script&lang=js"

import "./UpdatePolicyInfo.vue?vue&type=style&index=0&id=8ae5e34e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae5e34e"]])

export default __exports__